import React from "react";
import PropTypes from "prop-types";

import { GelboxImage } from "./GelboxImage";
import { GelboxTooltip } from "./GelboxTooltip";
import { GelboxControls } from "./GelboxControls";

import { GelPipetteModal } from "./GelPipetteModal";
import { GelOrientationModal } from "./GelOrientationModal";

import { I18nextProvider } from "react-i18next";
import i18next from "./locales/i18next";

import "./style.scss";

const i18n = i18next;

const changeLang = (lang) => {
  i18n.changeLanguage(lang);
};

export function GelBox(props) {
  const toggleShowTooltipControls = () => {
    props.toggleShowTooltipControls(!props.showTooltipControls);
  };

  const toggleShowOrientationModal = () => {
    if (!props.showTooltipControls) {
      toggleShowTooltipControls();
    }
    props.toggleShowOrientationModal(!props.showOrientationModal);
  };

  const toggleShowGelPipetteModal = () => {
    if (!props.showTooltipControls) {
      toggleShowTooltipControls();
    }
    props.toggleShowGelPipetteModal(!props.showGelPipetteModal);
  };

  const toggleIsOpen = () => {
    if (!props.showTooltipControls) {
      toggleShowTooltipControls();
    }
    props.toggleLid(!props.open);
  };

  React.useEffect(() => {
    props.lang && changeLang(props.lang);
  }, [props.lang]);

  return (
    <I18nextProvider i18n={i18n}>
      <div className="gelbox">
        <GelboxTooltip
          showControls={props.showTooltipControls}
          open={props.open}
          volume={props.volume}
          containsGel={props.containsGel}
          openShowOrientationModal={toggleShowOrientationModal}
          openShowGelPipetteModal={toggleShowGelPipetteModal}
          toggleLid={toggleIsOpen}
          onEjectGel={props.onEjectGel}
        />
        <GelboxControls
          open={props.open}
          volume={props.volume}
          containsGel={props.containsGel}
          toggleLid={toggleIsOpen}
          openShowOrientationModal={toggleShowOrientationModal}
          openShowGelPipetteModal={toggleShowGelPipetteModal}
          onInsertItem={props.onInsertItem}
        />
        <GelboxImage
          open={props.open}
          volume={props.volume}
          containsGel={props.containsGel}
          onSelect={toggleShowTooltipControls}
        />

        <GelPipetteModal
          id={props.id}
          isOpen={props.showGelPipetteModal}
          onClose={toggleShowGelPipetteModal}
          lanes={props.lanes}
          orientation={props.orientation}
          pipetteId={props.pipetteId}
          gelId={props.gelId}
          interactionProps={props.interactionProps}
          setGelLane={props.setGelLane}
          setGelActiveLane={props.setGelActiveLane}
          setPipetteSolution={props.setPipetteSolution}
          notebookExpanded={props.notebookExpanded}
          lang={props.lang}
        />

        <GelOrientationModal
          id={props.id}
          isOpen={props.showOrientationModal}
          onClose={toggleShowOrientationModal}
          orientation={props.orientation}
          lanes={props.lanes}
          decGelOrientation={props.decGelOrientation}
          incGelOrientation={props.incGelOrientation}
          //gelBoxId={props.gelBoxId}
          notebookExpanded={props.notebookExpanded}
          lang={props.lang}
        />
      </div>
    </I18nextProvider>
  );
}

GelBox.propTypes = {
  /**
   * Boolean to set if apparatus is open
   */
  isOpen: PropTypes.bool,
  /**
   * Boolean to set if digital contols modal should be displayed
   */
  showControlsModal: PropTypes.bool,
  /**
   * Boolean to set if tooltip controls should be displayed
   */
  showTooltipControls: PropTypes.bool,
  /**
   * Boolean to set if Balace Tubes Modal is displayed
   */
  showBalanceTubeModal: PropTypes.bool,
  /**
   * Function to open/close the apparatus lid
   */
  toggleLid: PropTypes.func,
  /**
   * Function to open/close the digital controls modal
   */
  toggleShowControlsModal: PropTypes.func,
  /**
   * Function to open/close the tooltip controls menus
   */
  toggleShowTooltipControls: PropTypes.func,
  /**
   * Function to open/close balance tubes modal
   */
  toggleShowBalanceTubeModal: PropTypes.func,
  /**
   * List of tubes in apparatus with its status.
   */
  slots: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Type of Tube placed in slot
       */
      tubeType: PropTypes.string,
      /**
       * boolean to specify if solution placed
       */
      solution: PropTypes.bool,
      /**
       * Boolean to specify if rotor placed
       */
      rotor: PropTypes.bool,
    })
  ),
  lanes: PropTypes.lanes,
  /**
   * Funciton to eject all tubes
   */
  onEjectTube: PropTypes.func,
  /**
   * Function to eject all rotors
   */
  onEjectRotor: PropTypes.func,
  /**
   * Boolean to set if the Gelbox tubes are balanced
   */
  balanced: PropTypes.bool,
  /**
   * Current rpm value set
   */
  rpmValue: PropTypes.number,
  /**
   * Current Runtime set
   */
  timeValue: PropTypes.instanceOf(Date),
  /**
   * Time left for centrifuge to run to completion
   */
  timeLeft: PropTypes.instanceOf(Date),
  /**
   * Function to set RPM value
   */
  setRPM: PropTypes.func,
  /**
   * Function to set Run Time
   */
  setTimeValue: PropTypes.func,
  /**
   * Function to invoke when to  run the Centrifuge
   */
  runCentrifuge: PropTypes.func,
  /**
   * Function to check if tubes are balanced
   */
  checkBalance: PropTypes.func,
  /**
   * Function to invoke when solution tube is dropped
   */
  onTubeDrop: PropTypes.func,
  /**
   * Function to insert item into centrifuge
   */
  onInsertItem: PropTypes.func,
  /**
   * Function to alert an event
   */
  alert: PropTypes.func,
};

GelBox.defaultProps = {};
